import { primitives } from './primitives.ts';
import type { Density } from '../preferences/preferences.store.ts';

const { space, fontSize } = primitives;

const spaciousFontSize = {
  xs: '14px',
  sm: '16px',
  md: '17px',
  lg: '20px',
  xl: '24px',
  '2xl': '34px',
  '3xl': '40px',
} as const satisfies Readonly<Record<keyof typeof fontSize, string>>;

export const densityTokens = {
  compact: {
    density: {
      row: '40px',
      rowHead: '36px',
      cellInline: space[3],
      cardPad: space[3],
      gap: space[3],
      pagePad: space[4],
      navItem: '36px',
      fontRow: fontSize.xs,
      chart: '13rem',
    },
    control: { height: '44px', heightCompact: '36px' },
    font: { size: fontSize },
  },
  comfortable: {
    density: {
      row: '48px',
      rowHead: '44px',
      cellInline: space[5],
      cardPad: space[4],
      gap: space[4],
      pagePad: space[6],
      navItem: '44px',
      fontRow: fontSize.sm,
      chart: '16rem',
    },
    control: { height: '44px', heightCompact: '40px' },
    font: { size: fontSize },
  },
  spacious: {
    density: {
      row: '64px',
      rowHead: '52px',
      cellInline: space[6],
      cardPad: space[6],
      gap: space[6],
      pagePad: space[8],
      navItem: '56px',
      fontRow: spaciousFontSize.md,
      chart: '20rem',
    },
    control: { height: '52px', heightCompact: '48px' },
    font: { size: spaciousFontSize },
  },
} as const satisfies Readonly<Record<Density, unknown>>;

export const ROW_HEIGHTS: Readonly<Record<Density, number>> = { compact: 40, comfortable: 48, spacious: 64 };
